import { useMemo } from "react";

import FireMatrix from "../FireMatrix";
import buildFireMatrixData from "../builders/buildFireMatrixData";

export default function FireSection({
    incendioMonitor
}) {

    const matrixData = useMemo(
        () => buildFireMatrixData(incendioMonitor),
        [incendioMonitor]
    );

    return (
        <FireMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Incêndio"
            rows={[
                {
                    value: "FALHA DO SISTEMA",
                    key: "falhaSistema"
                },
                {
                    value: "ALARME INCÊNDIO",
                    key: "alarmeIncendio"
                }
            ]}
            matrixData={matrixData}
        />
    );
}